import React, { ReactNode, useRef } from 'react';
import TruncateTextCmp from 'src/components/TruncateText';

import { SHARE_MOBILE_ROW_TEXT } from './shareMobile.styles';

interface IProps {
    label: string;
    value?: string | ReactNode | null;
    isLoading?: boolean;
    loadingPlaceholder?: string;
    align?: 'center' | 'start';
    isLabelLoading?: boolean;
    // Share-link mobile sheet: label + value both in text-tertiary per Figma.
    isShareMobile?: boolean;
}

const CardInfoRow: React.FC<IProps> = ({ label, value, isLoading = false, loadingPlaceholder = 'lorem ipsum dolor', align = 'center', isLabelLoading = false, isShareMobile = false }) => {
    const valueRef = useRef<HTMLParagraphElement>(null);
    const valueClassName = `text-xs leading-[18px] font-medium text-textSecondary text-right truncate ${isLoading ? 'custom-loading' : ''} ${isShareMobile ? SHARE_MOBILE_ROW_TEXT : ''}`;
    const labelClassName = `text-xs leading-[18px] text-textSecondary font-normal flex-none ${isLabelLoading ? 'custom-loading' : ''} ${isShareMobile ? SHARE_MOBILE_ROW_TEXT : ''}`;

    const isStringValue = typeof value === 'string' || value === null || value === undefined;
    const displayValue = isLoading ? loadingPlaceholder : isStringValue ? ((value as string | null | undefined) ? (value as string | null | undefined) : '-') : '';

    // String value path supports inline HTML (e.g. <sup> ordinals from getDateWithSuffixFormat)
    // via dangerouslySetInnerHTML so tags don't show as literal text. ReactNode path renders the
    // node directly without truncation/tooltip wrapping so callers can compose their own UI.
    if (!isStringValue && !isLoading) {
        return (
            <div className={`flex ${align === 'start' ? 'items-start' : 'items-center'} justify-between gap-x-4`}>
                <p className={labelClassName}>{isLabelLoading ? 'lorem ipsum dolor' : label}</p>
                <div className={`${valueClassName} !truncate-none`}>{value}</div>
            </div>
        );
    }

    const valueElement = isLoading ? (
        <p ref={valueRef} className={valueClassName}>
            {displayValue as string}
        </p>
    ) : (
        <p ref={valueRef} className={valueClassName} dangerouslySetInnerHTML={{ __html: displayValue as string }} />
    );
    // CP's TruncateTextCmp takes a plain string message, so strip any inline HTML
    // (e.g. <sup> ordinals) rather than passing a node through.
    const tooltipMessage = (displayValue as string)?.replace(/<[^>]*>/g, '') ?? '';

    return (
        <div className={`flex ${align === 'start' ? 'items-start' : 'items-center'} justify-between gap-x-4`}>
            <p className={labelClassName}>{isLabelLoading ? 'lorem ipsum dolor' : label}</p>
            <TruncateTextCmp message={tooltipMessage} refName={valueRef}>
                {valueElement}
            </TruncateTextCmp>
        </div>
    );
};

export default CardInfoRow;
